module.exports = "<div class=\"footer text-xs no-radius text-white text-center\"> version </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/footer.html
// module id = 177
// module chunks = 0